import { Navigate, Outlet } from "react-router-dom";
import { useUser } from "../context/UserContext";

const AdminOutlet = () => {
  const { user, loading } = useUser();

  if (loading) return null;

  return user?.token ? <Outlet /> : <Navigate to="/login" replace />;
};

export default AdminOutlet;
